import { DELETE_MANAGER_PLACE_ROUTE } from '@/utils/CONST';
import extractIdFromURI from '@/utils/id';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';

interface Props {
    itemUriId: string;
}

const ActionField = ({ itemUriId }: Props) => {
    const navigate = useNavigate();

    const handleOpenDeleteModal = () => {
        navigate(`${DELETE_MANAGER_PLACE_ROUTE}/${extractIdFromURI(itemUriId)}`);
    };

    return (
        <IconButton
            onClick={handleOpenDeleteModal}
            color={'primary'}
            sx={{
                p: 0,
            }}
            data-cy={'unlink-user'}
        >
            <LinkOffIcon />
        </IconButton>
    );
};

export default ActionField;
